import React, {forwardRef, useImperativeHandle} from 'react'
import {Grid} from "semantic-ui-react"
import DropDown from "../../../../components/commonComponents/formComponents/dropDown";
import InputField from '../../../../components/commonComponents/formComponents/inputField';
import { processTypeIdentificationVal, clearanceResultVal } from '../mockConstants';

const ExportErrorMock = forwardRef((props, ref) => {
    const [arrivalDate, setArrivalDate] = React.useState("");
    const [clearanceResult, setClearResult] = React.useState("");
    const [processTypeIdentification, setProType] = React.useState("");
    useImperativeHandle(ref, () => ({
        getProcess4Data: () =>  ({
            arrivalDate,
            clearanceResult,
            processTypeIdentification
        })
    }));
    return ( 
        <>
            <Grid.Row className="entry-number-row">
                <Grid.Column computer={5}>
                    <InputField
                        type="date"
                        isLabel={false}
                        className={'field-bg'}
                        label="Arrival Date"
                        value={arrivalDate}
                        onChange={(value) => setArrivalDate(value)}
                    />
                </Grid.Column>
                <Grid.Column computer={5}>
                    <DropDown 
                        style={{"borderColor": "#1765AE"}}
                        type="text"
                        id='processType'
                        label="Process Type Identification"
                        className="status-dropdown field-bg dropdown100"
                        data={processTypeIdentificationVal}
                        value={processTypeIdentification === -1 ? "SELECT" : processTypeIdentification}
                        onChange={(value) => setProType(value)}
                    />
                </Grid.Column>
                <Grid.Column computer={5}>
                    <DropDown 
                        style={{"borderColor": "#1765AE"}}
                        type="text"
                        id='clearanceResult'
                        label="Clearnace Result"
                        className="status-dropdown field-bg dropdown100"
                        data={clearanceResultVal}
                        value={clearanceResult === -1 ? "SELECT" : clearanceResult}
                        onChange={(value) => setClearResult(value)}
                    />
                </Grid.Column>
            </Grid.Row>
        </>
     );
})
 
export default ExportErrorMock;